'use strict';

var template  = require('../templates/PersonalSettings.ejs');
var PanelView = require('commons/views/PersonalSettingsPanel');

module.exports = PanelView.extend({
    initialize: function(options) {
        this.options = _.defaults(options || {}, {template: template});
        return PanelView.prototype.initialize.apply(this, [this.options]);
    },

    bindHandlers: function() {
        var r = PanelView.prototype.bindHandlers.apply(this, arguments);

        this.on('save', () => app.company.save({
            officerDesignation: this.$('#officerDesignation').val() || ''
        }), this);

        this.on('saved', () => app.company.fetch({validate: false}), this);

        return r;
    },

    unbindHandlers: function() {
        var r = PanelView.prototype.bindHandlers.apply(this, arguments);
        this.off('saved', null, this);
        return r;
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/PersonalSettings.js